import { render, staticRenderFns } from "./MyOrganizationNews.vue?vue&type=template&id=5747a3f9"
import script from "./MyOrganizationNews.vue?vue&type=script&lang=js"
export * from "./MyOrganizationNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports